import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { Auth } from '../../services/auth/auth';

export type LandingHeroTextSegment = Readonly<{
  text: string;
  accent?: boolean;
}>;

export type LandingHeroAction = Readonly<{
  label: string;
  routerLink?: string;
  href?: string;
  register?: boolean;
}>;

@Component({
  selector: 'app-landing-hero',
  imports: [LucideAngularModule, NgOptimizedImage, RouterLink],
  templateUrl: './landing-hero.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
  },
})
export class LandingHero {
  readonly heading = input.required<string>();
  readonly leadSegments = input.required<readonly LandingHeroTextSegment[]>();
  readonly bodyText = input.required<string>();
  readonly imagePath = input.required<string>();
  readonly imageAlt = input.required<string>();
  readonly primaryAction = input<LandingHeroAction | null>(null);
  readonly secondaryAction = input<LandingHeroAction | null>(null);
  private readonly auth = inject(Auth);

  signUp(): void {
    this.auth.signUp();
  }
}
